import getUserGroups from "../groups/getUserGroups";
import getPeople from "../people/getPeople";
import Data from "../types/Data";

export default function getUserGroupsAndPeople(data: Data) {
  return [...getUserGroups(data), ...getPeople(data)];
}
